//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "error-500"
};